<template>
    <div ref="conditions">
        <div class="my-6">
            <base-button
                @click="onNewCriteria"
                type="primary"
                outline
            >
                <span class="font-semibold">
                    {{ $t('report.newCriteria') }}
                </span>
            </base-button>
        </div>
        <div class="w-full flex flex-col content-wrapper_step-1 px-2" id="content-wrapper_step-1">
            <ConditionGroup
                v-for="(group, index) in reportTriggerData"
                class="flex w-full"
                :key="index"
                @on-delete-condition="onDeleteCondition"
                @on-add-condition="onAddCondition(index)"
                @on-delete-group="onDeleteGroup(index)"
                :can-delete="canDelete"
                :conditions="group"
                :reportItemData="reportItemData"
                :index="index"
                :amountOfReportTriggerDataLength="reportTriggerData.length"
            />
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            reportTriggerTypeList: {
                type: Array,
                default: () => []
            },
            conditionFilterColumnTypeList: {
                type: Array,
                default: () => []
            },
            widgetTemplateList: {
                type: Array,
                default: () => []
            },
            reportTriggerData: {
                type: Array,
                default: () => []
            },
            reportItemData: {
                type: Object,
                default: () => ({})
            }
        },
        components: {
            ConditionGroup: () => import('@/modules/reports/components/schedule/components/ConditionGroup')
        },
        computed: {
            canDelete() {
                return this.reportTriggerData.length > 1
            }
        },
        methods: {
            onAddCondition(index) {
                this.$emit('createNewCondition', index)
            },
            onDeleteCondition(groupIndex, itemIndex) {
                const data = {
                    groupIndex,
                    itemIndex
                }

                this.$emit('deleteCondition', data)
            },
            onDeleteGroup(index) {
                this.$emit('deleteCriteria', index)
            },
            onNewCriteria() {
                this.$emit('createNewCriteria')
                this.$nextTick(() => {
                    const element = document.getElementById('content-wrapper_step-1')
                    element.scrollTo({
                        top: element.scrollHeight,
                        behavior: 'smooth'
                    })
                })
            }
        },
        mounted () {
            if (!this.reportTriggerData[0].ReportTriggerConditionFilter.length) {
               this.onAddCondition(0) 
            }
        }
    }
</script>
<style lang="scss" scoped>
.content-wrapper_step-1 {
    height: 100%;
    min-height: calc(95vh - 305px);
    max-height: calc(95vh - 305px);
    @apply overflow-auto;
}
</style>
